
import { useState, useEffect } from "react";

function Section({ tab, setTab, textContent }) {

  const [arrayCoreValues, setArrayCoreValues] = useState([]);

  useEffect(() => {
  setArrayCoreValues(textContent?.aboutUs?.coreValues?.values || []);
  }, [textContent?.aboutUs?.coreValues?.values]);

  return (
    <section
      className={`tab-content ${tab === 4 ? "active" : ""}`}
      id="tab-mission"
    >
      <div className="section-content">
        <div className="section-text">
          <h2>{textContent?.aboutUs?.visionMission?.vision.title}</h2>
          <strong>
            "{textContent?.aboutUs?.visionMission?.vision.content}"
          </strong>

          <br />
          <br />

          <h2>{textContent?.aboutUs?.visionMission?.mission.title}</h2>
          <strong>
            "{textContent?.aboutUs?.visionMission?.mission.content}"
          </strong>

          <br />
          <br />
          <br />

          {/* Core Values */}
          <center>
            <h2 style={{ textDecoration: "underline" }}>{textContent?.aboutUs?.coreValues?.heading}</h2>
            <br />

            <ul className="service-list">
            
              {arrayCoreValues.map((value, index) => (
                <li className="service-item">
                <h3>{value.title}</h3>
                <img src={`images/mission/${index}.webp`} alt="" />
                <p>
                  {value.description}
                </p>
              </li>
              ))}
              
            </ul>

            <button className="cta-button" onClick={() => setTab(1)}>
              {textContent?.aboutUs?.coreValues?.cta}
            </button>
          </center>
        </div>
      </div>
    </section>
  );
}

export default Section;
